import React from 'react';
import { AppRoute } from '@launchpad';
import BaseModule from '@launchpad/logic/module/BaseModule';

export const NAME = 'transactions';

export default class TransactionsModule extends BaseModule {
  getName() {
    return NAME;
  }

  getPermission() {
    return 'transactions.*';
  }

  getPolicy() {
    return 'Admin:Transaction:View:*';
  }

  getNavigation() {
    return [
      {
        label: 'Transactions',
        icon: 'exchange',
        path: '/transaction',
        permission: 'transactions.*',
        policy: 'Admin:Transaction:View:*',
      },
    ];
  }

  getRoutes(currentUrl = '') {
    return [
      <AppRoute
        path={`${currentUrl}transaction`}
        load={() => import('./TransactionsNavigation')}
      />,
    ];
  }
}
